export const comparisonTableData = {
  columns: [
    { key: "onlineInitiation", labelKey: "breeders.comparison.table.onlineInitiation" },
    { key: "onlineAdvanced", labelKey: "breeders.comparison.table.onlineAdvanced" },
    { key: "presencial", labelKey: "breeders.comparison.table.presencial" }
  ],
  rows: [
    {
      featureKey: "breeders.comparison.table.level",
      cells: {
        onlineInitiation: "breeders.comparison.table.levels.initiation",
        onlineAdvanced: "breeders.comparison.table.levels.intermediate", 
        presencial: "breeders.comparison.table.levels.initiationIntermediate"
      }
    },
    {
      featureKey: "breeders.comparison.table.duration",
      cells: {
        onlineInitiation: "breeders.comparison.table.durations.online",
        onlineAdvanced: "breeders.comparison.table.durations.online",
        presencial: "breeders.comparison.table.durations.presencial"
      }
    },
    {
      featureKey: "breeders.comparison.table.format",
      cells: {
        onlineInitiation: "breeders.comparison.table.formats.online",
        onlineAdvanced: "breeders.comparison.table.formats.online",
        presencial: "breeders.comparison.table.formats.presencial"
      }
    },
    {
      featureKey: "breeders.comparison.table.group",
      cells: {
        onlineInitiation: "breeders.comparison.table.groups.online",
        onlineAdvanced: "breeders.comparison.table.groups.online",
        presencial: "breeders.comparison.table.groups.presencial"
      }
    },
    {
      featureKey: "breeders.comparison.table.includesPractice",
      cells: {
        onlineInitiation: false,
        onlineAdvanced: false,
        presencial: true
      }
    },
    {
      featureKey: "breeders.comparison.table.idealForLabel",
      cells: {
        onlineInitiation: "breeders.comparison.table.idealFor.initiation",
        onlineAdvanced: "breeders.comparison.table.idealFor.advanced",
        presencial: "breeders.comparison.table.idealFor.presencial"
      }
    },
    {
      featureKey: "breeders.comparison.table.documentationLabel",
      cells: {
        onlineInitiation: "breeders.comparison.table.documentation.initiation",
        onlineAdvanced: "breeders.comparison.table.documentation.advanced",
        presencial: "breeders.comparison.table.documentation.presencial"
      }
    },
    {
      featureKey: "breeders.comparison.table.introduction",
      cells: {
        onlineInitiation: true,
        onlineAdvanced: false,
        presencial: true
      }
    },
    {
      featureKey: "breeders.comparison.table.safety",
      cells: {
        onlineInitiation: true,
        onlineAdvanced: false,
        presencial: true
      }
    },
    {
      featureKey: "breeders.comparison.table.sterileTechnique",
      cells: {
        onlineInitiation: true,
        onlineAdvanced: false,
        presencial: true
      }
    },
    {
      featureKey: "breeders.comparison.table.meristems",
      cells: {
        onlineInitiation: true,
        onlineAdvanced: false,
        presencial: true
      }
    },
    {
      featureKey: "breeders.comparison.table.generationZero",
      cells: {
        onlineInitiation: false,
        onlineAdvanced: true,
        presencial: true
      }
    },
    {
      featureKey: "breeders.comparison.table.mediaPreparation",
      cells: {
        onlineInitiation: false,
        onlineAdvanced: true,
        presencial: true
      }
    },
    {
      featureKey: "breeders.comparison.table.syntheticSeeds",
      cells: {
        onlineInitiation: false,
        onlineAdvanced: true,
        presencial: true
      }
    },
    {
      featureKey: "breeders.comparison.table.acclimatation",
      cells: {
        onlineInitiation: false,
        onlineAdvanced: true,
        presencial: true
      }
    },
    {
      featureKey: "breeders.comparison.table.thermotherapy",
      cells: {
        onlineInitiation: false,
        onlineAdvanced: true,
        presencial: true
      }
    },
    {
      featureKey: "breeders.comparison.table.pathogenTest",
      cells: {
        onlineInitiation: false,
        onlineAdvanced: true,
        presencial: false
      }
    },
    {
      featureKey: "breeders.comparison.table.postCourseSupport",
      cells: {
        onlineInitiation: "breeders.comparison.table.support.online",
        onlineAdvanced: "breeders.comparison.table.support.online",
        presencial: "breeders.comparison.table.support.presencial"
      }
    },
    {
      featureKey: "breeders.comparison.table.protocols",
      cells: {
        onlineInitiation: true,
        onlineAdvanced: true,
        presencial: true
      }
    },
    {
      featureKey: "breeders.comparison.table.certificate",
      cells: {
        onlineInitiation: true,
        onlineAdvanced: true,
        presencial: true
      }
    },
    {
      featureKey: "breeders.comparison.table.recording",
      cells: {
        onlineInitiation: true,
        onlineAdvanced: true,
        presencial: true
      }
    },
    {
      featureKey: "breeders.comparison.table.price",
      cells: {
        onlineInitiation: "299 €",
        onlineAdvanced: "299 €",
        presencial: "1.499 €"
      }
    },
    {
      featureKey: "enroll",
      cells: {
        onlineInitiation: "enroll",
        onlineAdvanced: "enroll",
        presencial: "enroll"
      }
    }
  ],
  notes: {
    "breeders.comparison.table.includesPractice-presencial": "breeders.comparison.table.practices.included"
  }
};


export const scheduleData = {
  dates: [
    {
      id: "online-introduccion",
      start: "11 y 12 diciembre 2025",
      titleKey: "breeders.calendar.courses.0.title",
      buttonKey: "breeders.calendar.courses.0.button",
      dateKey: "breeders.calendar.courses.0.date"
    },
    {
      id: "online-avanzado", 
      start: "18 y 19 diciembre 2025",
      titleKey: "breeders.calendar.courses.1.title",
      buttonKey: "breeders.calendar.courses.1.button",
      dateKey: "breeders.calendar.courses.1.date"
    },
    {
      id: "presencial",
      start: "9 y 10 diciembre 2025", 
      titleKey: "breeders.calendar.courses.2.title",
      buttonKey: "breeders.calendar.courses.2.button",
      dateKey: "breeders.calendar.courses.2.date"
    }
  ],
  faq: [
    {
      categoryKey: "breeders.faqs.categories.0.title",
      questions: [
        { qKey: "breeders.faqs.categories.0.questions.0.question", aKey: "breeders.faqs.categories.0.questions.0.answer" },
        { qKey: "breeders.faqs.categories.0.questions.1.question", aKey: "breeders.faqs.categories.0.questions.1.answer" },
        { qKey: "breeders.faqs.categories.0.questions.2.question", aKey: "breeders.faqs.categories.0.questions.2.answer" },
        { qKey: "breeders.faqs.categories.0.questions.3.question", aKey: "breeders.faqs.categories.0.questions.3.answer" }
      ]
    },
    {
      categoryKey: "breeders.faqs.categories.1.title", 
      questions: [
        { qKey: "breeders.faqs.categories.1.questions.0.question", aKey: "breeders.faqs.categories.1.questions.0.answer" },
        { qKey: "breeders.faqs.categories.1.questions.1.question", aKey: "breeders.faqs.categories.1.questions.1.answer" },
        { qKey: "breeders.faqs.categories.1.questions.2.question", aKey: "breeders.faqs.categories.1.questions.2.answer" }
      ]
    },
    {
      categoryKey: "breeders.faqs.categories.2.title",
      questions: [
        { qKey: "breeders.faqs.categories.2.questions.0.question", aKey: "breeders.faqs.categories.2.questions.0.answer" },
        { qKey: "breeders.faqs.categories.2.questions.1.question", aKey: "breeders.faqs.categories.2.questions.1.answer" },
        { qKey: "breeders.faqs.categories.2.questions.2.question", aKey: "breeders.faqs.categories.2.questions.2.answer" },
        { qKey: "breeders.faqs.categories.2.questions.3.question", aKey: "breeders.faqs.categories.2.questions.3.answer" },
        { qKey: "breeders.faqs.categories.2.questions.4.question", aKey: "breeders.faqs.categories.2.questions.4.answer" }
      ]
    },
    {
      categoryKey: "breeders.faqs.categories.3.title",
      questions: [
        { qKey: "breeders.faqs.categories.3.questions.0.question", aKey: "breeders.faqs.categories.3.questions.0.answer" },
        { qKey: "breeders.faqs.categories.3.questions.1.question", aKey: "breeders.faqs.categories.3.questions.1.answer" },
        { qKey: "breeders.faqs.categories.3.questions.2.question", aKey: "breeders.faqs.categories.3.questions.2.answer" },
        { qKey: "breeders.faqs.categories.3.questions.3.question", aKey: "breeders.faqs.categories.3.questions.3.answer" }
      ]
    }
  ]
};